export const EntityNameRegex = /^[\w@#\-()*'" ]+$/;
export const EntityIDdigitsRegex = /^[0-9]+$/;

export const CountryOptions = {
  US: 'United States',
  NZ: 'New Zealand',
} as const;

export const CountryListItems = Object.values(CountryOptions);

// This Translations are based on Figma content provided
export const PasswordSettings = {
  required: 'Required',
  minLength: () => 'Must be at least 12 characters',
  maxLength: ({ count }: { count: number }) => `Must under ${count} characters`,
  trim: 'Must not begin or end with a space',
  repetitiveSequence: () => `That password is too repetitive`,
  context: 'That password is too easy to guess',
  dictionary: 'Password cannot be a commonly known password.',
  repeatRequired: 'Required',
  mustMatch: 'Passwords must be identical',
};
